import script from "./AdminAiPricingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAiPricingPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminAiPricingPage.vue?vue&type=style&index=0&id=1fddd6ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fddd6ff"]])

export default __exports__